function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, customPropTypes, getComponentType, getUnhandledProps, SUI, getKeyOnly } from '../lib';

/**
 * A label can be grouped.
 */
var LabelGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    circular = props.circular,
    className = props.className,
    color = props.color,
    content = props.content,
    size = props.size,
    tag = props.tag;
  var classes = cx('ui', color, size, getKeyOnly(circular, 'circular'), getKeyOnly(tag, 'tag'), 'labels', className);
  var rest = getUnhandledProps(LabelGroup, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
LabelGroup.displayName = 'LabelGroup';
LabelGroup.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** Primary content. */
  children: PropTypes.node,
  /** Labels can share shapes. */
  circular: PropTypes.bool,
  /** Additional classes. */
  className: PropTypes.string,
  /** Label group can share colors together. */
  color: PropTypes.oneOf(SUI.COLORS),
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,
  /** Label group can share sizes together. */
  size: PropTypes.oneOf(SUI.SIZES),
  /** Label group can share tag formatting. */
  tag: PropTypes.bool
};
export default LabelGroup;
//# sourceMappingURL=LabelGroup.js.map